import { AppModule } from 'app/module';

import './styles.scss';
import Template from './template.hbs';

export class Pagination extends AppModule {
    setTemplate() {
        this.template = Template;
        if (module.hot) {
            module.hot.accept('./template.hbs', () => {
                this.template = Template;
                this.render();
            });
        }
    }

    domBindings() {
        return {
            buttons: ['.m-pagination__button'],
            meta: '.m-pagination__meta',
        };
    }

    domEvents() {
        for (let i = 0; i < this.dom.buttons.length; i += 1) {
            this.dom.buttons[i].addEventListener(
                'click',
                (e) => this.buttonAction(e.currentTarget.getAttribute('data-page')),
            );
        }
    }

    buttonAction(page) {
        if (parseInt(page, 10) > -1) {
            this.events.emit('changed', { page });
        }
    }

    getJobsSearchProps() {
        const data = {};
        if (this.dom.meta) {
            data.page = parseInt(this.dom.meta.getAttribute('data-number'), 10);
        }
        return data;
    }
}
